module.exports = __webpack_public_path__ + "static/media/mappa-google-strade-senza-costruzioni.985f0653.png";